import './src/vaadin-message-list.js';
export * from './src/vaadin-message-list.js';
